'use client';

import { c as _c } from "react/compiler-runtime";
import { useState } from 'react';
import { useTranslations } from 'next-intl';
import { useNetlifyForm, netlifyFormMessage } from '@/components/use-netlify-form';
import { FormStatus } from '@/components/form-status';
import { DatePickerField } from '@/components/ui/date-picker';
import { TimePickerField } from '@/components/ui/time-picker';
interface ContactFormProps {
  locale: string;
}
export default function ContactFormWinterGeneral(t0) {
  const $ = _c(140);
  const {
    locale
  } = t0;
  const [needsPickup, setNeedsPickup] = useState(false);
  const [sameDayService, setSameDayService] = useState(false);
  const t = useTranslations("ContactWinter");
  const today = new Date().toISOString().split("T")[0];
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      setNeedsPickup(false);
      setSameDayService(false);
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    status: netlifyStatus,
    handleSubmit: handleNetlifySubmit
  } = useNetlifyForm(t1);
  let t2;
  let t3;
  let t4;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <input type="hidden" name="form-name" value="contact-winter-general" />;
    t3 = <input type="hidden" name="formType" value="general" />;
    t4 = <input type="hidden" name="season" value="winter" />;
    $[1] = t2;
    $[2] = t3;
    $[3] = t4;
  } else {
    t2 = $[1];
    t3 = $[2];
    t4 = $[3];
  }
  let t5;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <p className="hidden"><label>Don't fill this out if you're human: <input name="bot-field" /></label></p>;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  if ($[5] !== t) {
    t6 = t("firstName");
    $[5] = t;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] !== t6) {
    t7 = <label htmlFor="firstName" className="block text-base font-medium mb-2">{t6} *</label>;
    $[7] = t6;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <input type="text" id="firstName" name="firstName" required={true} className="w-full px-4 py-3 text-base border rounded-lg focus:ring-2 focus:ring-primary focus:border-transparent bg-background" />;
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  let t9;
  if ($[10] !== t7) {
    t9 = <div>{t7}{t8}</div>;
    $[10] = t7;
    $[11] = t9;
  } else {
    t9 = $[11];
  }
  let t10;
  if ($[12] !== t) {
    t10 = t("lastName");
    $[12] = t;
    $[13] = t10;
  } else {
    t10 = $[13];
  }
  let t11;
  if ($[14] !== t10) {
    t11 = <label htmlFor="lastName" className="block text-base font-medium mb-2">{t10} *</label>;
    $[14] = t10;
    $[15] = t11;
  } else {
    t11 = $[15];
  }
  let t12;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <input type="text" id="lastName" name="lastName" required={true} className="w-full px-4 py-3 text-base border rounded-lg focus:ring-2 focus:ring-primary focus:border-transparent bg-background" />;
    $[16] = t12;
  } else {
    t12 = $[16];
  }
  let t13;
  if ($[17] !== t11) {
    t13 = <div>{t11}{t12}</div>;
    $[17] = t11;
    $[18] = t13;
  } else {
    t13 = $[18];
  }
  let t14;
  if ($[19] !== t) {
    t14 = t("email");
    $[19] = t;
    $[20] = t14;
  } else {
    t14 = $[20];
  }
  let t15;
  if ($[21] !== t14) {
    t15 = <label htmlFor="email" className="block text-base font-medium mb-2">{t14} *</label>;
    $[21] = t14;
    $[22] = t15;
  } else {
    t15 = $[22];
  }
  let t16;
  if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = <input type="email" id="email" name="email" required={true} className="w-full px-4 py-3 text-base border rounded-lg focus:ring-2 focus:ring-primary focus:border-transparent bg-background" />;
    $[23] = t16;
  } else {
    t16 = $[23];
  }
  let t17;
  if ($[24] !== t15) {
    t17 = <div>{t15}{t16}</div>;
    $[24] = t15;
    $[25] = t17;
  } else {
    t17 = $[25];
  }
  let t18;
  if ($[26] !== t) {
    t18 = t("phone");
    $[26] = t;
    $[27] = t18;
  } else {
    t18 = $[27];
  }
  let t19;
  if ($[28] !== t18) {
    t19 = <label htmlFor="phone" className="block text-base font-medium mb-2">{t18}</label>;
    $[28] = t18;
    $[29] = t19;
  } else {
    t19 = $[29];
  }
  let t20;
  if ($[30] === Symbol.for("react.memo_cache_sentinel")) {
    t20 = <input type="tel" id="phone" name="phone" className="w-full px-4 py-3 text-base border rounded-lg focus:ring-2 focus:ring-primary focus:border-transparent bg-background" />;
    $[30] = t20;
  } else {
    t20 = $[30];
  }
  let t21;
  if ($[31] !== t19) {
    t21 = <div>{t19}{t20}</div>;
    $[31] = t19;
    $[32] = t21;
  } else {
    t21 = $[32];
  }
  let t22;
  if ($[33] !== t) {
    t22 = t("depositDate");
    $[33] = t;
    $[34] = t22;
  } else {
    t22 = $[34];
  }
  let t23;
  if ($[35] !== t22) {
    t23 = <label htmlFor="depositDate" className="text-base font-medium">{t22} *</label>;
    $[35] = t22;
    $[36] = t23;
  } else {
    t23 = $[36];
  }
  const t24 = locale === "fr" ? "ex: 15.12.2025" : "e.g. 15.12.2025";
  let t25;
  if ($[37] !== t24) {
    t25 = <span className="text-sm text-muted-foreground">{t24}</span>;
    $[37] = t24;
    $[38] = t25;
  } else {
    t25 = $[38];
  }
  let t26;
  if ($[39] !== t23 || $[40] !== t25) {
    t26 = <div className="flex items-center justify-between mb-2">{t23}{t25}</div>;
    $[39] = t23;
    $[40] = t25;
    $[41] = t26;
  } else {
    t26 = $[41];
  }
  const t27 = locale === "fr" ? "Heure de d\xE9p\xF4t" : "Deposit Time";
  let t28;
  if ($[42] !== t27) {
    t28 = <label htmlFor="depositTime" className="text-base font-medium">{t27}</label>;
    $[42] = t27;
    $[43] = t28;
  } else {
    t28 = $[43];
  }
  const t29 = locale === "fr" ? "ex: 09:00" : "e.g. 09:00";
  let t30;
  if ($[44] !== t29) {
    t30 = <span className="text-sm text-muted-foreground">{t29}</span>;
    $[44] = t29;
    $[45] = t30;
  } else {
    t30 = $[45];
  }
  let t31;
  if ($[46] !== t28 || $[47] !== t30) {
    t31 = <div className="flex items-center justify-between mb-2">{t28}{t30}</div>;
    $[46] = t28;
    $[47] = t30;
    $[48] = t31;
  } else {
    t31 = $[48];
  }
  const t32 = locale === "fr" ? "Choisir une heure" : "Pick a time";
  let t33;
  if ($[49] !== t32) {
    t33 = <TimePickerField name="depositTime" id="depositTime" placeholder={t32} />;
    $[49] = t32;
    $[50] = t33;
  } else {
    t33 = $[50];
  }
  let t34;
  if ($[51] !== t31 || $[52] !== t33) {
    t34 = <div>{t31}{t33}</div>;
    $[51] = t31;
    $[52] = t33;
    $[53] = t34;
  } else {
    t34 = $[53];
  }
  let t35;
  if ($[54] === Symbol.for("react.memo_cache_sentinel")) {
    t35 = <div className="flex-shrink-0 w-8 h-8 bg-green-500 rounded-full flex items-center justify-center"><svg className="w-5 h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v13m0-13V6a2 2 0 112 2h-2zm0 0V5.5A2.5 2.5 0 109.5 8H12zm-7 4h14M5 12a2 2 0 110-4h14a2 2 0 110 4M5 12v7a2 2 0 002 2h10a2 2 0 002-2v-7" /></svg></div>;
    $[54] = t35;
  } else {
    t35 = $[54];
  }
  let t36;
  if ($[55] !== t) {
    t36 = t("couponTitle");
    $[55] = t;
    $[56] = t36;
  } else {
    t36 = $[56];
  }
  let t37;
  if ($[57] !== t36) {
    t37 = <span className="font-bold text-sm text-foreground">{t36}</span>;
    $[57] = t36;
    $[58] = t37;
  } else {
    t37 = $[58];
  }
  let t38;
  if ($[59] === Symbol.for("react.memo_cache_sentinel")) {
    t38 = <span className="font-bold text-green-600 text-sm">-20%</span>;
    $[59] = t38;
  } else {
    t38 = $[59];
  }
  let t39;
  if ($[60] !== t37) {
    t39 = <div className="flex items-center gap-2 mb-1">{t37}{t38}</div>;
    $[60] = t37;
    $[61] = t39;
  } else {
    t39 = $[61];
  }
  let t40;
  if ($[62] !== t) {
    t40 = t("couponTitle");
    $[62] = t;
    $[63] = t40;
  } else {
    t40 = $[63];
  }
  let t41;
  if ($[64] !== t) {
    t41 = t("couponCodeLabel");
    $[64] = t;
    $[65] = t41;
  } else {
    t41 = $[65];
  }
  let t42;
  if ($[66] !== t40 || $[67] !== t41) {
    t42 = <input type="text" id="couponCode" name="couponCode" aria-label={t40} placeholder={t41} className="w-full px-3 py-2.5 text-base border rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent bg-background" />;
    $[66] = t40;
    $[67] = t41;
    $[68] = t42;
  } else {
    t42 = $[68];
  }
  let t43;
  if ($[69] !== t39 || $[70] !== t42) {
    t43 = <div className="bg-gradient-to-r from-green-50 to-emerald-50 border-2 border-green-200 rounded-lg p-4 shadow-sm"><div className="flex items-center gap-4">{t35}<div className="flex-1 min-w-0">{t39}{t42}</div></div></div>;
    $[69] = t39;
    $[70] = t42;
    $[71] = t43;
  } else {
    t43 = $[71];
  }
  let t44;
  if ($[72] !== t) {
    t44 = t("subject");
    $[72] = t;
    $[73] = t44;
  } else {
    t44 = $[73];
  }
  let t45;
  if ($[74] !== t44) {
    t45 = <label htmlFor="subject" className="block text-base font-medium mb-2 mt-6">{t44} *</label>;
    $[74] = t44;
    $[75] = t45;
  } else {
    t45 = $[75];
  }
  let t46;
  if ($[76] === Symbol.for("react.memo_cache_sentinel")) {
    t46 = <input type="text" id="subject" name="subject" required={true} className="w-full px-4 py-3 text-base border rounded-lg focus:ring-2 focus:ring-primary focus:border-transparent bg-background" />;
    $[76] = t46;
  } else {
    t46 = $[76];
  }
  let t47;
  if ($[77] !== t45) {
    t47 = <div>{t45}{t46}</div>;
    $[77] = t45;
    $[78] = t47;
  } else {
    t47 = $[78];
  }
  let t48;
  if ($[79] !== t) {
    t48 = t("idealDeliveryDate");
    $[79] = t;
    $[80] = t48;
  } else {
    t48 = $[80];
  }
  let t49;
  if ($[81] !== t48) {
    t49 = <label htmlFor="idealDeliveryDate" className="block text-base font-medium mb-2">{t48}</label>;
    $[81] = t48;
    $[82] = t49;
  } else {
    t49 = $[82];
  }
  let t50;
  if ($[83] !== t) {
    t50 = t("message");
    $[83] = t;
    $[84] = t50;
  } else {
    t50 = $[84];
  }
  let t51;
  if ($[85] !== t50) {
    t51 = <label htmlFor="message" className="block text-base font-medium mb-2">{t50} *</label>;
    $[85] = t50;
    $[86] = t51;
  } else {
    t51 = $[86];
  }
  let t52;
  if ($[87] !== t) {
    t52 = t("messagePlaceholder");
    $[87] = t;
    $[88] = t52;
  } else {
    t52 = $[88];
  }
  let t53;
  if ($[89] !== t52) {
    t53 = <textarea id="message" name="message" rows={8} required={true} placeholder={t52} className="w-full px-4 py-3 text-base border rounded-lg focus:ring-2 focus:ring-primary focus:border-transparent bg-background" />;
    $[89] = t52;
    $[90] = t53;
  } else {
    t53 = $[90];
  }
  let t54;
  if ($[91] !== t51 || $[92] !== t53) {
    t54 = <div>{t51}{t53}</div>;
    $[91] = t51;
    $[92] = t53;
    $[93] = t54;
  } else {
    t54 = $[93];
  }
  let t55;
  if ($[94] === Symbol.for("react.memo_cache_sentinel")) {
    t55 = e => setSameDayService(e.target.checked);
    $[94] = t55;
  } else {
    t55 = $[94];
  }
  let t56;
  if ($[95] !== sameDayService) {
    t56 = <input type="checkbox" name="sameDayService" checked={sameDayService} onChange={t55} className="mt-1 w-5 h-5 text-primary border-gray-300 rounded focus:ring-2 focus:ring-primary" />;
    $[95] = sameDayService;
    $[96] = t56;
  } else {
    t56 = $[96];
  }
  let t57;
  if ($[97] !== t) {
    t57 = t("sameDayService");
    $[97] = t;
    $[98] = t57;
  } else {
    t57 = $[98];
  }
  let t58;
  if ($[99] !== t57) {
    t58 = <span className="font-medium text-base text-foreground">{t57}</span>;
    $[99] = t57;
    $[100] = t58;
  } else {
    t58 = $[100];
  }
  const t59 = locale === "fr" ? "Besoin d'une r\xE9paration ou pr\xE9paration urgente ? Service le jour m\xEAme pour 5\u20AC suppl\xE9mentaires. Selon disponibilit\xE9." : "Need urgent repair or preparation? Same-day service for \u20AC5 extra. Subject to availability.";
  let t60;
  if ($[101] !== t59) {
    t60 = <p className="text-sm text-muted-foreground mt-1">{t59}</p>;
    $[101] = t59;
    $[102] = t60;
  } else {
    t60 = $[102];
  }
  let t61;
  if ($[103] !== t58 || $[104] !== t60) {
    t61 = <div className="flex-1">{t58}{t60}</div>;
    $[103] = t58;
    $[104] = t60;
    $[105] = t61;
  } else {
    t61 = $[105];
  }
  let t62;
  if ($[106] !== t56 || $[107] !== t61) {
    t62 = <div className="border rounded-lg p-4 bg-card"><label className="flex items-start gap-3 cursor-pointer">{t56}{t61}</label></div>;
    $[106] = t56;
    $[107] = t61;
    $[108] = t62;
  } else {
    t62 = $[108];
  }
  let t63;
  if ($[109] === Symbol.for("react.memo_cache_sentinel")) {
    t63 = e_0 => setNeedsPickup(e_0.target.checked);
    $[109] = t63;
  } else {
    t63 = $[109];
  }
  let t64;
  if ($[110] !== needsPickup) {
    t64 = <input type="checkbox" name="needsPickup" checked={needsPickup} onChange={t63} className="mt-1 w-5 h-5 text-primary border-gray-300 rounded focus:ring-2 focus:ring-primary" />;
    $[110] = needsPickup;
    $[111] = t64;
  } else {
    t64 = $[111];
  }
  let t65;
  if ($[112] !== t) {
    t65 = t("pickupDeliveryService");
    $[112] = t;
    $[113] = t65;
  } else {
    t65 = $[113];
  }
  let t66;
  if ($[114] !== t65) {
    t66 = <span className="font-medium text-base text-foreground">{t65}</span>;
    $[114] = t65;
    $[115] = t66;
  } else {
    t66 = $[115];
  }
  const t67 = locale === "fr" ? "Prise en charge et livraison dans un rayon de 20km pour 15\u20AC. Selon disponibilit\xE9." : "Pickup and delivery within 20km radius for \u20AC15. Subject to availability.";
  let t68;
  if ($[116] !== t67) {
    t68 = <p className="text-sm text-muted-foreground mt-1">{t67}</p>;
    $[116] = t67;
    $[117] = t68;
  } else {
    t68 = $[117];
  }
  let t69;
  if ($[118] !== t66 || $[119] !== t68) {
    t69 = <div className="flex-1">{t66}{t68}</div>;
    $[118] = t66;
    $[119] = t68;
    $[120] = t69;
  } else {
    t69 = $[120];
  }
  let t70;
  if ($[121] !== t64 || $[122] !== t69) {
    t70 = <label className="flex items-start gap-3 cursor-pointer">{t64}{t69}</label>;
    $[121] = t64;
    $[122] = t69;
    $[123] = t70;
  } else {
    t70 = $[123];
  }
  let t71;
  if ($[124] !== needsPickup || $[125] !== t) {
    t71 = needsPickup && <div className="mt-4 space-y-4 pt-4 border-t"><div><label htmlFor="pickupAddress" className="block text-base font-medium mb-2">{t("pickupAddress")} *</label><input type="text" id="pickupAddress" name="pickupAddress" required={needsPickup} placeholder={t("pickupAddressPlaceholder")} className="w-full px-4 py-3 text-base border rounded-lg focus:ring-2 focus:ring-primary focus:border-transparent bg-background" /></div><div className="grid grid-cols-1 md:grid-cols-3 gap-4"><div><label htmlFor="pickupCity" className="block text-base font-medium mb-2">{t("city")} *</label><input type="text" id="pickupCity" name="pickupCity" required={needsPickup} className="w-full px-4 py-3 text-base border rounded-lg focus:ring-2 focus:ring-primary focus:border-transparent bg-background" /></div><div><label htmlFor="pickupPostalCode" className="block text-base font-medium mb-2">{t("postalCode")} *</label><input type="text" id="pickupPostalCode" name="pickupPostalCode" required={needsPickup} className="w-full px-4 py-3 text-base border rounded-lg focus:ring-2 focus:ring-primary focus:border-transparent bg-background" /></div><div><label htmlFor="pickupPhone" className="block text-base font-medium mb-2">{t("pickupPhone")} *</label><input type="tel" id="pickupPhone" name="pickupPhone" required={needsPickup} placeholder="+33..." className="w-full px-4 py-3 text-base border rounded-lg focus:ring-2 focus:ring-primary focus:border-transparent bg-background" /></div></div></div>;
    $[124] = needsPickup;
    $[125] = t;
    $[126] = t71;
  } else {
    t71 = $[126];
  }
  let t72;
  if ($[127] !== t70 || $[128] !== t71) {
    t72 = <div className="border rounded-lg p-4 bg-card">{t70}{t71}</div>;
    $[127] = t70;
    $[128] = t71;
    $[129] = t72;
  } else {
    t72 = $[129];
  }
  const t73 = netlifyStatus === "submitting";
  let t74;
  if ($[130] !== locale || $[131] !== netlifyStatus || $[132] !== t) {
    t74 = netlifyStatus === "submitting" ? netlifyFormMessage(locale, "submitting") : t("submitButton");
    $[130] = locale;
    $[131] = netlifyStatus;
    $[132] = t;
    $[133] = t74;
  } else {
    t74 = $[133];
  }
  let t75;
  if ($[134] !== t73 || $[135] !== t74) {
    t75 = <button type="submit" disabled={t73} className="w-full bg-primary text-primary-foreground px-6 py-4 text-lg rounded-lg font-semibold hover:bg-primary/90 transition-colors shadow-md hover:shadow-lg disabled:opacity-60">{t74}</button>;
    $[134] = t73;
    $[135] = t74;
    $[136] = t75;
  } else {
    t75 = $[136];
  }
  let t76;
  if ($[137] !== locale || $[138] !== netlifyStatus) {
    t76 = <FormStatus status={netlifyStatus} locale={locale} />;
    $[137] = locale;
    $[138] = netlifyStatus;
    $[139] = t76;
  } else {
    t76 = $[139];
  }
  return <div className="bg-card rounded-lg border p-4 sm:p-6 lg:p-8 w-full max-w-[1440px] mx-auto"><form name="contact-winter-general" method="POST" data-netlify="true" netlify-honeypot="bot-field" onSubmit={handleNetlifySubmit} className="space-y-6">{t2}{t3}{t4}{t5}<div className="grid grid-cols-1 lg:grid-cols-12 gap-6"><div className="lg:col-span-4 space-y-4 lg:p-6 lg:bg-muted/30 lg:rounded-lg">{t9}{t13}{t17}{t21}<div>{t26}<DatePickerField name="depositDate" id="depositDate" locale={locale} required={true} minDate={new Date(today)} placeholder={locale === "fr" ? "Choisir une date" : "Pick a date"} /></div>{t34}{t43}</div><div className="lg:col-span-8 space-y-6">{t47}<div>{t49}<DatePickerField name="idealDeliveryDate" id="idealDeliveryDate" locale={locale} minDate={new Date(today)} placeholder={locale === "fr" ? "Choisir une date" : "Pick a date"} /></div>{t54}{t62}{t72}{t75}{t76}</div></div></form></div>;
}